// src/components/OCDDissolver/steps.js
export const steps = [
  "Pause. Take a deep breath in.",
  "Notice the urge. Don’t fight it—just observe.",
  "Remind yourself: 'This thought does not define me.'",
  "Choose an alternative action (press the button below).",
  "Smile gently. The cycle is breaking.",
];
